<template>
  <div class="reportWrapper">
    <div class="report-component" id="tr-at-a-glance-html">
      <div class="tr-at-a-glance">
        <div class="tr-at-a-glance__table">
          <AppAtAGlanceTable
            :cwa_data="cwaData"
            :my_aag="false"
            :user_aags="userAags"
            :imagespath="imagespath"
          />
        </div>
        <div class="tr-at-a-glance__legend">
          <AtAGlanceLegend :imagespath="imagespath" />
        </div>
        <div v-if="report.vimeo_id">
          <div class="tr-at-a-glance__content-container">
            <div class="tr-at-a-glance__video">
              <iframe
                :src="`https://player.vimeo.com/video/${report.vimeo_id}`"
                class="tr-at-a-glance__player"
                frameborder="0"
                webkitAllowFullScreen
                mozallowfullscreen
                allowFullScreen
                :style="{ width: deviceWidth + 'px', height: deviceWidth * 0.5617 + 'px' }"
              />
            </div>
            <div class="tr-at-a-glance__content">
              <div class="tr-at-a-glance__title">{{ report.name }}</div>
              <div class="tr-at-a-glance__published">
                {{ getPublishedDate }}.
              </div>
              <div class="tr-at-a-glance__summary">
                {{ report.summary }}
              </div>
            </div>
          </div>
          <div class="tr-at-a-glance__summary-transcription">
            <div
              class="tr-at-a-glance__summary-transcription__header"
              @click="open = !open"
              :class="open ? 'open' : ''"
            >
              <div class="tr-at-a-glance__summary-transcription__title">
                Summary Transcription
              </div>
              <div class="tr-at-a-glance__summary-transcription__icon">
                <IconChevronCircleDown :isActive="open" />
              </div>
            </div>
            <div
              class="tr-at-a-glance__summary-transcription__content"
              :class="open ? 'expand' : 'hide'"
            >
              <div
                class="tr-at-a-glance__summary-transcription__text"
                v-html="cwaData[0].Summary"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import AtAGlanceLegend from '~/components/trendsreport/html/AtAGlanceComponents/AtAGlanceLegend.vue';
  import AppAtAGlanceTable from '~/components/trendsreport/html/AtAGlanceComponents/AppAtAGlanceTable.vue';
  import IconChevronCircleDown from '~/components/icon/IconChevronCircleDown.vue';

  export default {
    name: 'AppAtAGlanceTemplate',
    components: {
      AtAGlanceLegend,
      IconChevronCircleDown,
      AppAtAGlanceTable,
    },
    props: {
      cwaData: {
        type: Object,
        required: false,
        default: () => ({
          ColumnHeaders: [],
          IndicatorData: [],
          Summary: '',
        }),
      },
      report: {
        type: Object,
        required: true,
      },
      imagespath: {
        type: String,
        required: true,
      },
      userAags: {
        type: [Array, Object],
        required: true,
      },
    },
    data: () => ({
      open: localStorage.getItem('aag-transcription-state')
        ? JSON.parse(localStorage.getItem('aag-transcription-state'))
        : false,        
    }),
    computed: {
      getPublishedDate() {
        return `Published ${moment(this.report.published_date).format('MMMM DD, YYYY')}`;
      },
      getTableClassName() {
        let hasHighlight = this.cwaData.some((rowData) =>
          rowData.IndicatorData.some((data) => !!data.Highlight)
        );
        return hasHighlight ? '' : 'no-highlights';
      },
      deviceWidth() {
        let width = window.innerWidth;
        if(width < 768) {
          return width - 40;
        }
        return width - 80;
      },
    },
    methods: {
      hasHighlights(data) {
        let highlights = false;
        if (
          data.ColumnHeaders[data.ColumnHeaders.length - 1] === 'Highlights'
        ) {
          highlights = true;
        }
        if (highlights) {
          let highlightsCount = 0;
          data.IndicatorData.forEach((rowData) => {
            if (rowData.Highlight !== '') {
              highlightsCount++;
            }
          });
          if (highlightsCount === 0) {
            highlights = false;
          }
        }
        return highlights;
      },
    },
    watch: {
      open(newVal) {
        localStorage.setItem('aag-transcription-state', JSON.stringify(newVal));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .tr-at-a-glance {
    &__table{
      margin-bottom: 1rem;
    }
    &__content-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
      gap: 1rem;
    }
    &__video {
      width: 100%;
      text-align: center;
    }
    &__player {
      border-radius: 10px;
    }
    &__content {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      border-radius: 10px;
      border: 1px solid var(--itr-tr-grey); 
      padding: 16px;
      width:100%;
    }
    &__title {
      color: var(--itr-blue-mid);
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 1rem;
    }
    &__published {
      font-size: 15px;
      font-style: italic;
      margin-bottom: 1rem;
    }
    &__summary {
      font-size: 15px;
      margin-top: 0.5rem;
    }

    &__summary-transcription {
      width: 100%;
      margin-top: 2rem;
      margin-bottom: 1rem;
      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: var(--itr-blue);
        padding: 10px 20px;
        border-radius: 10px;
        cursor: pointer;
        transition: ease-in-out 100ms;
      }
      &__header.open {
        border-radius: 10px 10px 0 0;
      }
      &__title {
        font-weight: bold;
        font-size: 20px;
        color: var(--itr-white);
      }
      &__content {
        border-radius: 0 0 10px 10px;
        border-left: 2px solid var(--itr-grey);
        border-right: 2px solid var(--itr-grey);
        border-bottom: 2px solid var(--itr-grey);
        padding: 16px 32px;
      }
      &__content.expand {
        height: 100%;
        visibility: visible;
        transition: ease-in-out 150ms;
        opacity: 1;
      }
      &__content.hide {
        height: 0px;
        visibility: hidden;
        overflow: hidden;
        opacity: 0;
      }
      &__text {
        * {
          font-size: 14px !important;
          color: var(--itr-charcoal) !important;
          background-color: transparent !important;
          font-family: 'Open Sans', sans-serif !important;
        }
      }
    }
    .test-class {
      opacity: 0.3;
    }
  }
</style>
